import axios from "axios";
import { env } from "@/shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const jobsClient = axios.create({
  baseURL: env.api.jobs,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(jobsClient);

export default jobsClient;
